module.exports = __webpack_public_path__ + "static/img/loading.c863daf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = 612
// module chunks = 4